module.exports = __webpack_public_path__ + "img/delete.34a21334.svg";